import React from 'react'

export default function FaceFeature({ scale, verticalOffset }) {
  const transformOrigin = '21.4 5.2'
  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M16.89 9.86006H3.12997C2.62997 9.86006 2.20996 9.45006 2.20996 8.94006L1.47998 1.49007C1.47998 0.990067 1.88996 0.570068 2.39996 0.570068H17.62C18.12 0.570068 18.54 0.980067 18.54 1.49007L17.81 8.94006C17.8 9.45006 17.39 9.86006 16.89 9.86006Z"
        stroke="#231F20"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M39.7298 9.86006H25.9698C25.4698 9.86006 25.0498 9.45006 25.0498 8.94006L24.3198 1.49007C24.3198 0.990067 24.7298 0.570068 25.2398 0.570068H40.4598C40.9598 0.570068 41.3798 0.980067 41.3798 1.49007L40.6498 8.94006C40.6398 9.45006 40.2298 9.86006 39.7298 9.86006Z"
        stroke="#231F20"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M18.6499 3.43995C18.6499 3.43995 21.2099 1.96995 23.9299 3.43995"
        stroke="#231F20"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
